// This file is autogenerated. Any changes will be overwritten.

import useUID from '../../../hooks/useUID';

export const set = 'streamline';

export const name = 'clock-solid';

export const Component = () => {
  const maskId = useUID();

  return (
    <>
      <defs>
        <mask id={maskId} fill='#000' stroke='#000' strokeLinecap='round'>
          <path fill='#fff' stroke='#fff' d='M0 0h18v18H0z' />
          <path d='M9 9V6.187M9 9l3.515 3.516' />
        </mask>
      </defs>
      <circle
        cx='9'
        cy='9'
        r='8'
        fill='currentColor'
        stroke='currentColor'
        mask={`url(#${maskId})`}
      />
    </>
  );
};

export const viewBox = '0 0 18 18';
